<template>
  <div class="shensu-info" v-loading="loading">
    <!-- 审核中 -->
     <template v-if="detail.auditStatus === 0">
        <div class="shensu-top">
          <img src="https://fenxiao.muruji.com/internalSystem/c4d0998c-1e84-4767-ac47-45347fcb3b59" class="img">
          <div class="shensu-title">审核中...</div>
          <div class="shensu-tips">正在审批该订单的提成改为<span class="danger">{{detail.bonusTypeLabel}}</span>的申请。</div>
        </div>
        <div class="shensu-content">
          <div class="form-row">
            <div class="lable">图片证据：</div>
            <div class="img-list">
              <div class="img" v-for="(url, index) of detail.urls" :key="index">
                <el-image class="image" :src="url" fit="contain"></el-image>
                <div class="look">查看</div>
                <el-image class="image image-click" :src="url" fit="contain" :preview-src-list="detail.urls"></el-image>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="lable">申诉备注：</div>
            <div class="text ">{{detail.reason}}</div>
          </div>
          <div class="form-row">
            <div class="lable">提交审核人：</div>
            <div class="text ">{{detail.applyName}}</div>
          </div>
          <div class="form-row">
            <div class="lable">提交时间：</div>
            <div class="text ">{{detail.applyTime}}</div>
          </div>
        </div>
        <div class="button-con">
          <el-button class="btn-cancel" @click="$emit('dialogVisible')">取 消</el-button>
          <!-- 本人才可以撤销申诉 -->
          <el-button class="btn-ok" type="primary" @click="cancelApply" v-if="detail.applyName === userInfo.reallyName">撤销申诉</el-button>
        </div>
    </template>
    <!-- 撤销 -->
    <template v-if="detail.auditStatus === 1">
          <div class="shensu-top">
            <img src="https://fenxiao.muruji.com/internalSystem/0985f322-bc3d-4fce-a4f0-a33fc0619288" class="img">
            <div class="shensu-title shensu-title-cancel">撤销申诉</div>
            <div class="shensu-tips">您已撤销订单的提成变更的申请。</div>
          </div>
          <div class="shensu-content">
            <div class="form-row">
              <div class="lable">图片证据：</div>
              <div class="img-list">
                <div class="img" v-for="(url, index) of detail.urls" :key="index">
                  <el-image class="image" :src="url" fit="contain" ></el-image>
                  <div class="look">查看</div>
                  <el-image class="image image-click" :src="url" fit="contain" :preview-src-list="detail.urls"></el-image>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="lable">申诉备注：</div>
              <div class="text ">{{detail.reason}}</div>
            </div>
            <div class="form-row">
              <div class="lable">撤销审核人：</div>
              <div class="text ">{{detail.applyName}}</div>
            </div>
            <div class="form-row">
              <div class="lable">撤销时间：</div>
              <div class="text ">{{detail.applyTime}}</div>
            </div>
          </div>
          <div class="button-con">
            <el-button class="btn-cancel" @click="$emit('dialogVisible')">取 消</el-button>
          </div>
    </template>
    <!-- 通过 -->
    <template v-if="detail.auditStatus === 2">
      <div class="shensu-top">
        <img src="https://fenxiao.muruji.com/internalSystem/84cfe386-00bd-4c92-b0e3-ea1dac4051a0" class="img">
          <div class="shensu-title shensu-title-success">审核结果：{{detail.auditStatusLabel}}</div>
          <div class="shensu-tips">系统提成类型更改为<span class="danger">{{detail.bonusTypeLabel}}</span></div>
        </div>
        <div class="shensu-content">
          <div class="form-row">
            <div class="lable">图片证据：</div>
            <div class="img-list">
              <div class="img" v-for="(url, index) of detail.urls" :key="index">
                <el-image class="image" :src="url" fit="contain"></el-image>
                <div class="look">查看</div>
                <el-image class="image image-click" :src="url" fit="contain" :preview-src-list="detail.urls"></el-image>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="lable">申诉备注：</div>
            <div class="text ">{{detail.reason}}</div>
          </div>
          <div class="form-row">
            <div class="lable">审核人：</div>
            <div class="text ">{{detail.auditUserName}}</div>
          </div>
          <div class="form-row">
            <div class="lable">审核时间：</div>
            <div class="text ">{{detail.applyTime}}</div>
          </div>
          <div class="form-row">
            <div class="lable">审核备注：</div>
            <div class="text ">{{detail.auditRemarks}}</div>
          </div>
        </div>
        <div class="button-con">
          <el-button class="btn-ok" type="primary" plain @click="$emit('dialogVisible')">好 的</el-button>
        </div>
    </template>
    <!-- 驳回 -->
    <template v-if="detail.auditStatus === 3">
      <div class="shensu-top">
        <img src="https://fenxiao.muruji.com/internalSystem/504f2ae5-1656-4515-8eab-b243fc95139f" class="img">
          <div class="shensu-title shensu-title-danger">审核结果：{{detail.auditStatusLabel}}</div>
          <div class="shensu-tips">提成申诉失败，订单提成仍为<span class="danger">{{detail.oldBonusTypeLabel}}</span></div>
        </div>
        <div class="shensu-content">
          <div class="form-row">
            <div class="lable">图片证据：</div>
            <div class="img-list">
              <div class="img" v-for="(url, index) of detail.urls" :key="index">
                <el-image class="image" :src="url" fit="contain"></el-image>
                <div class="look">查看</div>
                <el-image class="image image-click" :src="url" fit="contain" :preview-src-list="detail.urls"></el-image>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="lable">申诉备注：</div>
            <div class="text ">{{detail.reason}}</div>
          </div>
          <div class="form-row">
            <div class="lable">审核人：</div>
            <div class="text ">{{detail.auditUserName}}</div>
          </div>
          <div class="form-row">
            <div class="lable">审核时间：</div>
            <div class="text ">{{detail.applyTime}}</div>
          </div>
          <div class="form-row">
            <div class="lable">审核备注：</div>
            <div class="text ">{{detail.auditRemarks}}</div>
          </div>
        </div>
        <div class="button-con">
          <el-button class="btn-ok" type="primary" plain @click="$emit('dialogVisible')">好 的</el-button>
        </div>
    </template>
     <!-- 被修改 -->
     <template v-if="detail.auditStatus === 4">
      <div class="shensu-top">
        <img src="https://fenxiao.muruji.com/internalSystem/a2b91ead-64de-4729-bc7f-eac4db967a7c" class="img">
          <div class="shenhe-tips">系统提成类型更改为<span class="danger">{{detail.bonusTypeLabel}}</span>。</div>
        </div>
        <div class="shensu-content">
          <div class="form-row">
            <div class="lable">图片证据：</div>
            <div class="img-list">
              <div class="img" v-for="(url, index) of detail.urls" :key="index">
                <el-image class="image" :src="url" fit="contain"></el-image>
                <div class="look">查看</div>
                <el-image class="image image-click" :src="url" fit="contain" :preview-src-list="detail.urls"></el-image>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="lable">修改备注：</div>
            <div class="text ">{{detail.reason}}</div>
          </div>
          <div class="form-row">
            <div class="lable">修改人：</div>
            <div class="text ">{{detail.applyName}}</div>
          </div>
          <div class="form-row">
            <div class="lable">修改时间：</div>
            <div class="text ">{{detail.applyTime}}</div>
          </div>
        </div>
        <div class="button-con">
          <el-button class="btn-ok" type="primary" plain @click="$emit('dialogVisible')">好 的</el-button>
        </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'check-shensu',
  data () {
    return {
      userInfo: {},
      loading: false,
      detail: {}
    }
  },
  props: {
    orderObj: { // 订单
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    orderObj (val, oldVal) {
      this.detail = {}
      const id = val.orderBonusResponse && val.orderBonusResponse.id || val.applyId
      console.log(val)
      this.$forceUpdate()
      this.getDetail(id) // 查询审批结果
    }
  },
  created () { },
  mounted () {
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    this.$nextTick(() => {
      console.log(this.orderObj)
      this.detail = {}
      const id = this.orderObj.orderBonusResponse && this.orderObj.orderBonusResponse.id || this.orderObj.applyId
      this.getDetail(id)
      this.$forceUpdate()
    })
  },
  methods: {
    // 获取详情
    getDetail (id) {
      this.loading = true
      this.$api.bonusApplyDetail(id).then((res) => {
        if (res.code === 0) {
          const detail = res.data
          // 字符串转数组
          if (detail.fileUrls) {
            detail.urls = detail.fileUrls.split(',')
          }
          this.detail = detail
        }
        this.loading = false
      }).catch((err) => {
        this.detail = {}
        console.log(err)
        this.loading = false
      })
    },
    // 撤销申诉
    cancelApply () {
      this.loading = true
      const id = this.orderObj.orderBonusResponse.id
      this.$api.bonusApplyCancel(id).then((res) => {
        if (res.code === 0) {
          this.$emit('submitState')
          this.getDetail(id)
        }
        this.loading = false
      }).catch((err) => {
        this.detail = {}
        console.log(err)
        this.loading = false
      })
    },
  }
}
</script>
